import { PayloadAction } from '../../../store.model';
import { SortOptions } from '../../table';
import { sortRows } from '../function/sort-rows.function';
import { ActionType } from '../main.action';
import { MainState } from '../main.state';

import { SortRows } from './sort-rows.action';

export function sortRowsReducer(
    state: MainState,
    action: PayloadAction<ActionType.MI2_MAIN__SORT_ROWS, SortRows>,
): MainState {
    try {
        const currentSortState: SortOptions = state.sortOptions ?? {
            columnId: null,
            order: null,
        };
        let nextSortOrder = action.payload.options?.order;
        if (currentSortState.columnId === action.payload.options?.columnId) {
            nextSortOrder = currentSortState.order === 'asc' ? 'desc' : 'asc';
        }
        const nextSortOptions: SortOptions = {
            ...currentSortState,
            columnId: action.payload.options?.columnId,
            order: nextSortOrder,
        };

        const nextFilteredDirectReports = sortRows(
            state.filteredRows,
            nextSortOptions,
        );

        return {
            ...state,
            sortOptions: nextSortOptions,
            filteredRows: nextFilteredDirectReports,
        };
    } catch {
        return {
            ...state,
        };
    }
}
